<form class="list-group" [formGroup]="form">
  @for (ref of page; track ref; let idx = $index) {
    <label class="list-group-item" [for]="'problem-' + idx">
      <h5 class="flex items-center gap-2">
        <p-checkbox
          [inputId]="'problem-' + idx"
          [binary]="true"
          [formControl]="formControl(ref)" />
        <span>
          @if (ref.citation === 'N/A') {
            General issue
          } @else {
            Relates to source no. {{ ref.citation }}
          }
        </span>
      </h5>
      <p>
        <strong>Description:</strong>
        {{ ref.description }}
      </p>
      <p>
        <strong>Suggestion:</strong>
        {{ ref.instruction }}
      </p>
      <p>
        <strong>Original fact:</strong>
        {{ ref.original_fact }}
      </p>
    </label>
  }
</form>

@if (problems.length > pageSize) {
  <p-paginator
    [first]="pageIndex"
    [rows]="pageSize"
    [pageLinkSize]="pageLinkSize"
    [totalRecords]="problems.length"
    [showPageLinks]="true"
    [showFirstLastIcon]="false"
    (onPageChange)="onPageChange($event)" />
}
